export default "__VITE_ASSET__CceaRVbE__"